import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import { getInterFontWeightCSS } from '../theme';
import { tokens } from './tokens';
export const AsteriskIcon = ()=>{
    return /*#__PURE__*/ _jsx(StyledAsteriskIcon, {
        children: "*"
    });
};
const StyledAsteriskIcon = styled.span`
  color: ${tokens.Label.Asterisk.color};
  font-size: ${tokens.Label.Asterisk.fontSize};
  ${getInterFontWeightCSS(tokens.Label.Asterisk.fontWeight)};
  line-height: ${tokens.Label.Asterisk.lineHeight};
`;
